var render, staticRenderFns
import script from "./CrtApp.vue?vue&type=script&lang=js&"
export * from "./CrtApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e357d5d')) {
      api.createRecord('2e357d5d', component.options)
    } else {
      api.reload('2e357d5d', component.options)
    }
    
  }
}
component.options.__file = "src/views/Configuration/App/CrtApp.vue"
export default component.exports